import { Link } from "react-router-dom";
import { mdiShieldCheck } from "@mdi/js";
import Icon from "@mdi/react";
import dayjs from "dayjs";

import Button from "components/Button";
import Rater from "components/Rater";
import Tooltip from "components/Tooltip";
import { ILoadBid } from "models/Load";
import styles from "./style.module.scss";

type BidCarrierInfoProps = {
  isDeleted: boolean;
  bid: ILoadBid;
  setAcceptBidId: (value: string) => void;
  goToUserProfile: VoidFunction;
  toggleAcceptBidModalOpen: VoidFunction;
};

export default function BidInfo({
  isDeleted,
  bid,
  setAcceptBidId,
  toggleAcceptBidModalOpen,
  goToUserProfile
}: Readonly<BidCarrierInfoProps>) {
  return (
    <>
      <ul className={styles.bidItemContainer}>
        <li>Company:</li>
        <li className={styles.company}>
          <span>{bid.user.contactName}</span>
          <Button
            variant="text"
            className="!px-0 h-auto mr-auto !text-info mt-1"
            onClick={goToUserProfile}>
            View Profile
          </Button>
        </li>

        <li>Info:</li>
        <li className={styles.info}>
          <span>MC#: {bid.user.mc}</span>
          <span>DOT#: {bid.user.dot}</span>
          <span>
            Email:{" "}
            <a href={`mailto:${bid.user.email}`} className="underline">
              {bid.user.email}
            </a>
          </span>
          <span>
            Phone Number:{" "}
            <a href={`tel:+1${bid.user.contactPhone}`} className="underline text-info">
              {bid.user.contactPhone}
            </a>
          </span>
        </li>

        <li>Current Bid:</li>
        <li className={styles.currentBid}>
          <span>Submitted {dayjs(bid.created).format("MM/DD/YYYY hh:MM A")}</span>
          <span>Note: {bid.bidderNotes}</span>
          {bid.bidStatus === "pending" ? (
            <>
              {!isDeleted && (
                <Button
                  className="!px-2 !py-2 h-max"
                  onClick={() => {
                    setAcceptBidId(bid.id);
                    toggleAcceptBidModalOpen();
                  }}>
                  Accept Bid ${bid.amount.toFixed(2)}
                </Button>
              )}
            </>
          ) : (
            <>
              {bid.bidStatus === "accepted" ? (
                <Button className="!px-2 !py-2 h-max !bg-success" onClick={goToUserProfile}>
                  You accepted this bid of ${bid.amount.toFixed(2)}
                </Button>
              ) : (
                <>
                  {!isDeleted && (
                    <Button className="!px-2 !py-2 h-max !bg-red-600">
                      This bid of ${bid.amount.toFixed(2)} was retracted
                    </Button>
                  )}
                </>
              )}
            </>
          )}
        </li>

        <li>Reporting:</li>
        <li className={styles.reporting}>
          <Rater value={bid.user?.averageRating ? Number(bid.user.averageRating) / 20 : 0} />
          <div className="flex justify-between">
            <Button variant="text" className="!text-info !p-0 h-8" onClick={goToUserProfile}>
              Rate This User
            </Button>
            <Link
              to="https://safer.fmcsa.dot.gov/query.asp"
              target="_blank"
              className={styles.FMCSALink}>
              FMCSA Report
            </Link>
          </div>

          <Tooltip
            position="center"
            wrapperClass="!w-64"
            message="This carrier has been verified for liability insurance, business legitimacy and authority compliance. We still recommend verifying cargo insurance and other requirements with the carrier as needed.">
            <div className={styles.verifiedCarrier}>
              <Icon path={mdiShieldCheck} className="text-primary size-4" />
              <span>Haul Pay Verified Carrier</span>
            </div>
          </Tooltip>
        </li>
      </ul>
    </>
  );
}
